import { defineComponent } from "vue";

/**
 * 渲染 `Wifi` SVG 图标。
 *
 * @remarks
 * Vue 透传属性（如 `class`、`style`、`role`、`aria-label`、`width`、`height` 和 `fill`）会应用到根 `<svg>` 元素。
 */
export const Wifi = defineComponent({
	name: "Wifi",
	render() {
		return (
			<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1024 1024">
				<path d="M562.04 741.98q0 4.92-0.96 9.78-0.96 4.8-2.88 9.36-1.86 4.56-4.62 8.64-2.7 4.14-6.18 7.62-3.48 3.48-7.62 6.18-4.08 2.76-8.64 4.62-4.56 1.92-9.36 2.88T512 792.02q-4.92 0-9.72-0.96t-9.42-2.88q-4.5-1.86-8.64-4.62-4.08-2.7-7.56-6.18-3.48-3.48-6.24-7.62-2.7-4.08-4.62-8.64-1.86-4.56-2.82-9.36t-0.96-9.78q0-4.92 0.96-9.72t2.82-9.42q1.92-4.5 4.62-8.64 2.76-4.08 6.24-7.56 3.48-3.48 7.56-6.24 4.14-2.7 8.64-4.62 4.56-1.86 9.42-2.82Q507.08 692 512 692t9.78 0.96q4.8 0.96 9.36 2.82 4.56 1.92 8.64 4.62 4.14 2.76 7.62 6.24 3.48 3.48 6.18 7.56 2.76 4.14 4.62 8.64 1.92 4.56 2.88 9.42 0.96 4.8 0.96 9.72zM330.74 617.06q36.9-36.84 84.84-56.28Q461.84 542 512 542q50.1 0 96.42 18.78 47.94 19.44 84.78 56.28a30 30 0 1 1-42.42 42.42q-28.26-28.2-64.92-43.14Q550.4 602 512 602q-38.46 0-73.92 14.4-36.6 14.82-64.86 43.08a30 30 0 1 1-42.48-42.42z m392.4-333.24q93.9 38.88 168.18 109.26a30 30 0 0 0 41.28-43.56q-82.32-78-186.48-121.14-100.8-41.7-210.3-45.9-109.08-4.2-212.58 29.22-106.38 34.44-193.68 104.46-19.8 15.9-38.22 33.36a30 30 0 0 0 41.28 43.56q16.68-15.78 34.5-30.12 78.66-63.12 174.6-94.2 93.36-30.18 191.76-26.34 98.76 3.84 189.66 41.4zM351.8 393.2Q272 425.48 210.68 486.8a30 30 0 1 0 42.48 42.36q52.62-52.62 121.02-80.4Q440.3 422 512 422q71.64 0 137.7 26.82 68.4 27.72 121.08 80.4a30 30 0 1 0 42.36-42.48q-61.2-61.2-140.88-93.6Q595.34 362 512 362q-83.4 0-160.32 31.2z" />
			</svg>
		);
	},
});

export default Wifi;
